import { useTranslation } from "react-i18next";
import { Button } from "@/shared/ui";

type Props = {
  onSave: () => void;
  onCancel: () => void;
  isSaving: boolean;
};

export default function SettingsButtons({ onCancel, onSave, isSaving }: Props) {
  const { t } = useTranslation("chat");

  return (
    <div className="grid grid-cols-2 items-center gap-3">
      <Button
        className="h-[2.625rem]"
        onClick={(e) => {
          e.stopPropagation();
          onSave();
        }}
        loading={isSaving}
        disabled={isSaving}
      >
        {t("chat.save")}
      </Button>
      <Button
        variant="solid-surface-gradient"
        className="h-[2.625rem]"
        onClick={onCancel}
        disabled={isSaving}
      >
        {t("chat.cancel")}
      </Button>
    </div>
  );
}
